import script from "./Rater.vue?vue&type=script&setup=true&lang=js"
export * from "./Rater.vue?vue&type=script&setup=true&lang=js"

import "./Rater.vue?vue&type=style&index=0&id=9e2347a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e2347a4"]])

export default __exports__